export const getImagePathForClubFacilityIcon = (mobileNavIcon: string): string => {
  switch (mobileNavIcon) {
    case 'Spa':
      return '/fixed-images/club-facilities-mobile-nav-icons/spa.png';
    case 'Creche':
      return '/fixed-images/club-facilities-mobile-nav-icons/creche.png';
    case 'Gym':
      return '/fixed-images/club-facilities-mobile-nav-icons/gym.png';
    case 'Exercise Classes':
      return '/fixed-images/club-facilities-mobile-nav-icons/group-ex.png';
    case 'Kids Club':
      return '/fixed-images/club-facilities-mobile-nav-icons/kids.png';
    case 'Pools':
      return '/fixed-images/club-facilities-mobile-nav-icons/pool.png';
    case 'Tennis':
      return '/fixed-images/club-facilities-mobile-nav-icons/tennis.png';
    case 'Padel':
      return '/fixed-images/club-facilities-mobile-nav-icons/padel.png';
    default:
      throw new Error(`Unrecognised Image icon - ${mobileNavIcon}`);
  }
};
